<template>
  <v-main>
    <v-container>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-card-text class="ma-0">
              Tus cambios se han registrado con éxito, gracias por utilizar nuestra plataforma.
          </v-card-text>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
/* eslint-disable no-console*/

export default {
  data() {
    return {
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>

</style>
